<template>
  <div class="coupon-card-container">
    <img v-lazy="item.image" alt="coupon image" />
    <div
      class="coupon-content"
      @click="onClickShowDetail ? onClickShowDetail(item) : () => {}"
    >
      <div class="coupon-title">{{ item.title }}</div>
        <button
        v-if="
          item && item.active === undefined && item.couponRedeemRemaining === 0
        "
        disabled
        class="btn"
        @click="onClick(item)"
      >
        หมดแล้ว
      </button>
      <template v-else>
        <button
          v-if="
            (item &&
              item.active === undefined &&
              item.couponRedeemMaxUser > 0 &&
              item.couponRedeemRemainingUser > 0) ||
            (item &&
              item.active === undefined &&
              item.couponRedeemMaxUser === 0)
          "
          class="btn"
          @click="onClick(item)"
        >
          เก็บคูปอง
        </button>
        <button
          v-if="
            item &&
            item.active === undefined &&
            item.couponRedeemMaxUser > 0 &&
            item.couponRedeemRemainingUser === 0 &&
            item.couponRedeemRemaining > 0
          "
          disabled
          class="btn"
          @click="onClick(item)"
        >
          เก็บแล้ว
        </button>
        <button
          v-if="item && item.active === true"
          class="btn"
          @click="onClick(item)"
        >
          ใช้งาน
        </button>
        <button
          v-if="item && item.active === false && item.used"
          disabled
          class="btn"
          @click="onClick(item)"
        >
          ใช้แล้ว
        </button>
        <button
          v-if="item && item.active === false && item.expired && !item.used"
          disabled
          class="btn"
          @click="onClick(item)"
        >
          หมดอายุ
        </button>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  methods: {},
  props: {
    item: {
      type: Object,
    },
    onClick: {
      type: Function,
    },
    onClickShowDetail: {
      type: Function,
    },
  },
};
</script>

<style lang="scss" scope>
.coupon-card-container {
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  font-size: 12px;
  display: flex;
  height: 100px;
  cursor: pointer;
  background-color: white;
  transition: background-color 0.15s ease;
}
.coupon-card-container:hover {
  background-color: #f7f7f7;
}
.coupon-content {
  margin: 16px;
  margin-left: 0;
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.coupon-title {
  line-height: 15px;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.coupon-content button {
  font-size: 12px;
  margin-top: auto;
  padding: 0;
  line-height: 1;
  height: 22px;
  width: 100px;
  border-radius: 4px;
  background-color: #005224;
  color: white;
}
.coupon-card-container > img {
  width: 35%;
  margin: 16px;
  border-radius: 8px;
  object-fit: cover;
}
</style>
